import { useState } from 'react';

const useFetchData = (apiUrl, endPoint) => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = async (filters = {}) => {
    setLoading(true);
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value != null) {
        queryParams.append(key, value);
      }
    });
    const url = `${apiUrl}${endPoint}?${queryParams.toString()}`;
    try {
      const res = await fetch(url, { credentials: 'include' });
      const data = await res.json();
      setStats(data);
    } catch (err) {
      console.error('Error fetching stats:', err);
    } finally {
      setLoading(false);
    }
  };

  return { stats, loading, fetchData };
};

export default useFetchData;